export default class Calendrier {
  constructor(element) {
    this.element = element;

    // Events
    this.events = [];
    const eventListItems = this.element.querySelectorAll(".event-list .new-event-list-item");

    eventListItems.forEach(item => {
    const title = item.querySelector(".new-event-title").innerText;
    const date = item.querySelector(".new-event-date").innerText;

    this.events.push({ date, title });
    });

    this.textNoEvent = this.element.querySelector("#eventDetails").innerText;
    


    // Update today's date
    this.currentDate = new Date();

    this.init();
  }

  init() {
    this.element.querySelector(".js-prev").onclick = this.prevMonth.bind(this);
    this.element.querySelector(".js-next").onclick = this.nextMonth.bind(this);

    this.renderCalendar();
    this.showClosestOnLoad();
  }

  // Helper to format date to "YYYY-MM-DD"
  formatDate(date) {
    return date.toISOString().split("T")[0];
  }

  getClosestEvent() {
    const today = new Date();
    today.setHours(0,0,0,0);

    const upcoming = this.events
      .map(e => ({ ...e, diff: new Date(e.date) - today }))
      .filter(e => e.diff >= 0)
      .sort((a,b) => a.diff - b.diff);

    return upcoming[0] || null;
  }

  renderCalendar() {
    const calendar = this.element.querySelector(".js-calendar");
    const monthYear = this.element.querySelector(".js-monthYear");

    // Container reset
    calendar.innerHTML = "";

    const closest = this.getClosestEvent(); 

    const year = this.currentDate.getFullYear();
    const month = this.currentDate.getMonth();

    // Print the date in monthYear
    const monthName = this.currentDate.toLocaleString("fr-FR", { month: "long", year: "numeric" }).split(" ")[0];
    const monthNameCapitalized = monthName.charAt(0).toUpperCase() + monthName.slice(1);
    monthYear.innerText = monthNameCapitalized + " " + this.currentDate.getFullYear();

    // Header of days of week
    const daysOfWeek = ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"];
        daysOfWeek.forEach(day => {
        const dayHeader = document.createElement("div");
        dayHeader.classList.add("day-of-week");
        dayHeader.innerText = day + ".";
        calendar.appendChild(dayHeader);
    });


    // Finds day of 1 month -> always 1
    const firstDay = new Date(year, month, 1).getDay();

    // Finds last day of month -> ex : 31
    const daysInMonth = new Date(year, month + 1, 0).getDate();


    for (let i = 0; i < firstDay; i++) {
        const emptyDiv = document.createElement("div");
        calendar.appendChild(emptyDiv);
    }

    for (let day = 1; day <= daysInMonth; day++) {
      // Creates the date of the day's index - ex : new Day (2026, 03, 01)
      const dateObj = new Date(year, month, day);

      // Puts date in string format because of the events' format (line 7 to 9)- ex : "2026-03-01"
      const dateStr = this.formatDate(dateObj);

      // Creates the divs for each day of the month
      const dayDiv = document.createElement("button");
      dayDiv.classList.add("day");
      dayDiv.setAttribute("tabindex", "0");
      const dayHeading = document.createElement("h3");
      dayHeading.innerText = day;
      dayDiv.appendChild(dayHeading);

      const today = new Date();
      today.setHours(0, 0, 0, 0);

      // Compare the date of the day with today's date (in string format) and adds a class if it's the same
      if (this.formatDate(today) === dateStr) {
          dayDiv.classList.add("today");
          dayDiv.classList.add("is-selected");
      }

      // Check for events with the same date as the day and adds a class + event listener if it exists
      // ex : item = { date:"2026-03-10", title:"Atelier créatif" }
      const event = this.events.find(item => item.date === dateStr);
      if (event) {
        dayDiv.classList.add("event-day");
        dayDiv.addEventListener("click", () => {
            const currentActive = this.element.querySelector(".is-selected");
            if (currentActive) currentActive.classList.remove("is-selected");
            dayDiv.classList.add("is-selected");

            this.showEvent(event);
        });
      }

      else {
        dayDiv.classList.add("non-event-day");
        dayDiv.addEventListener("click", () => {
            const currentActive = this.element.querySelector(".is-selected");
            if (currentActive) currentActive.classList.remove("is-selected");
            dayDiv.classList.add("is-selected");

            this.showNonEvent(dateStr);
        });
      }

      calendar.appendChild(dayDiv);
    }
  }

  showEvent(event) {
    const eventDetails = document.getElementById("eventDetails");

    // Empty de container
    eventDetails.innerHTML = "";

    // Date
    const dateDiv = document.createElement("h3");
    dateDiv.classList.add("event-date");
    const [year, month, day] = event.date.split("-").map(Number);
    const eventDateObj = new Date(year, month - 1, day);
    dateDiv.innerText = eventDateObj.toLocaleDateString("fr-FR", {
        day: "numeric",
        month: "long",
        year: "numeric"
    });

    // Title
    const titleDiv = document.createElement("div");
    titleDiv.classList.add("event-title");
    titleDiv.innerText = event.title;

    eventDetails.appendChild(dateDiv);
    eventDetails.appendChild(titleDiv);
  }

  showNonEvent(dateStr) {
    const eventDetails = document.getElementById("eventDetails");

    // Empty de container
    eventDetails.innerHTML = "";

    // Date
    const dateDiv = document.createElement("h3");
    dateDiv.classList.add("event-date");
    const [year, month, day] = dateStr.split("-").map(Number);
    const eventDateObj = new Date(year, month - 1, day);
    dateDiv.innerText = eventDateObj.toLocaleDateString("fr-FR", {
        day: "numeric",
        month: "long",
        year: "numeric"
    });

    // Title
    const titleDiv = document.createElement("div");
    titleDiv.classList.add("event-title");    
    titleDiv.innerText = this.textNoEvent;

    eventDetails.appendChild(dateDiv);
    eventDetails.appendChild(titleDiv);
  }


  showClosestOnLoad() {
    const today = new Date();
    const dateStr = this.formatDate(today);
    
    // Check for an event on today's date
    const eventToday = this.events.find(item => item.date === dateStr);

    if (eventToday) {
      this.showEvent(eventToday);
    } else {
      this.showNonEvent(dateStr);
    }
    this.renderCalendar();
  }

  prevMonth() {
    this.currentDate.setMonth(this.currentDate.getMonth() - 1);
    this.renderCalendar();
  }

  nextMonth() {
    this.currentDate.setMonth(this.currentDate.getMonth() + 1);
    this.renderCalendar();
  }
}
